// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1l1bJ","title":"AfterBackImages_title__3wYCB","images":"AfterBackImages_images__2ESbD"};